export const environment = {
  production: true,
  apiUrl: '/api',
  // Client API ORIGIN (no /api suffix) — used only by the public /enroll page (cross-origin; CORS-allowed).
  clientApiUrl: 'https://clientapi.lapitechsoftwaresolutions.com',
};
